var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_170186",
    "data-name": "Grupo 170186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.021,
    height: 35.003,
    viewBox: "0 0 36.021 35.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150855",
    "data-name": "Rect\\xE1ngulo 150855",
    width: 36.021,
    height: 35.003,
    fill: "#f3f2ee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170183",
    "data-name": "Grupo 170183",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86238",
    "data-name": "Trazado 86238",
    d: "M34.125,15.475H21.382V6h1.992A5.25,5.25,0,0,0,26.29,4.8h0a1.419,1.419,0,0,0,.174-1.918,2.566,2.566,0,0,0-2.5-.949c-1.3.2-2.811,1.245-4.137,3.723h.452a.57.57,0,0,1,.569.569V34.408a.583.583,0,0,1-.569.595H15.74a.583.583,0,0,1-.569-.595V6.221a.57.57,0,0,1,.569-.569h.452c-1.326-2.478-2.834-3.526-4.137-3.723a2.566,2.566,0,0,0-2.5.949A1.419,1.419,0,0,0,9.728,4.8h0A5.25,5.25,0,0,0,12.647,6h1.992v9.48H.948A.948.948,0,0,1,0,14.527V6.944A.948.948,0,0,1,.948,6H8.26a3.216,3.216,0,0,1-.247-4.214A4.461,4.461,0,0,1,12.337.055c1.865.283,3.978,1.686,5.674,5,1.7-3.312,3.808-4.715,5.674-5a4.46,4.46,0,0,1,4.324,1.726A3.216,3.216,0,0,1,27.762,6h7.311a.948.948,0,0,1,.948.948v7.583a.948.948,0,0,1-.948.948h-.948Z",
    transform: "translate(0 0)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86239",
    "data-name": "Trazado 86239",
    d: "M112.406,73.9H99.663V92.478h11.8a.948.948,0,0,0,.948-.948Z",
    transform: "translate(-78.281 -58.044)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86240",
    "data-name": "Trazado 86240",
    d: "M21.581,92.478V73.9H8.838V91.531a.948.948,0,0,0,.948.948Z",
    transform: "translate(-6.942 -58.044)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegalo);
export default __webpack_public_path__ + "static/media/Regalo.78e7721b54c57f223be410cd4d548790.svg";
export { ForwardRef as ReactComponent };